import styled from '../../../../../../styles/styledComponents/themeComponents';

export const WidgetPreviewHeaderStyle = styled.div`
  text-align: center;
  padding: 10px;

  &:not(.is-empty) {
    padding: 10px 15px;
  }

  letter-spacing: -0.1px;

  .require-info {
    font-size: 18px;
    padding: 0 10px;
  }

  .widget-main-title {
    font-size: 18px;
    font-weight: bold;
    line-height: 1.22;
    text-align: center;
  }

  .widget-sub-title {
    font-size: 12px;
    color: #9b9b9b;
    line-height: 1.5;
    text-align: center;
  }
`;
